import { atom, useRecoilState } from "recoil";
import { useEffect } from "react";

const themeAtom = atom({
  key: "themeAtom",
  default: "system", // "light" | "dark" | "system"
});

export default function useTheme() {
  const [theme, setTheme] = useRecoilState(themeAtom);

  // const getSystemTheme = () => (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
  const getSystemTheme = () => "light";

  const applyTheme = (mode) => {
    const finalTheme = mode === "system" ? getSystemTheme() : mode;
    localStorage.setItem("themePref", finalTheme);
    document.documentElement.classList.toggle("dark", finalTheme === "dark");
  };

  // 🔹 On first load
  useEffect(() => {
    const savedTheme = localStorage.getItem("themePref") || "system";
    setTheme(savedTheme);
    applyTheme(savedTheme);
  }, []);

  // 🔹 Listen for system theme changes (only if system mode)
  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");

    const handler = () => {
      if (theme === "system") {
        applyTheme("system");
      }
    };

    media.addEventListener("change", handler);
    return () => media.removeEventListener("change", handler);
  }, [theme]);

  // 🔹 User toggle (overrides system)
  const toggleTheme = () => {
    const nextTheme = theme === "dark" ? "light" : "dark";
    setTheme(nextTheme);
    localStorage.setItem("themePref", nextTheme);
    applyTheme(nextTheme);
  };

  return { theme, toggleTheme };
}
